import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
// import { HOURLY_TIME_PERIOD } from '../../config/constants/analytics';
import SectionCard from './components/SectionCard';
import ChartTabs from './components/ChartTabs';
import CancelledBasketSizeHeatmapChart from './Heatmap/CancelledBasketSizeHeatmapChart';
import CompletedBasketSizeHeatmapChart from './Heatmap/CompletedBasketSizeHeatmapChart';
import CancelledBasketSizeLineChart from './LineChart/CancelledBasketSizeLineChart';
import CompletedBasketSizeLineChart from './LineChart/CompletedBasketSizeLineChart';
import { makeSelectProperty } from './selectors';
const AvgBasketSizeChart = ({
  selectedTimePeriod,
  isTimePeriodFilterStatusChanged,
}) => {
  // const isHourly = selectedTimePeriod.slug === HOURLY_TIME_PERIOD; // No HeatMap
  const isHourly = false;
  const COMPARISON_TABS = [
    {
      id: 1,
      title: 'Completed Basket Size',
      tabContent: null,
    },
    {
      id: 2,
      title: 'Cancelled Basket Size',
      tabContent: null,
    },
  ];
  let tabContentOne;
  if (!isTimePeriodFilterStatusChanged) {
    tabContentOne = isHourly ? (
      <CompletedBasketSizeHeatmapChart />
    ) : (
      <CompletedBasketSizeLineChart />
    );
  } else {
    tabContentOne = COMPARISON_TABS[0].tabContent;
  }
  COMPARISON_TABS[0].tabContent = tabContentOne;

  let tabContentTwo;
  if (!isTimePeriodFilterStatusChanged) {
    tabContentTwo = isHourly ? (
      <CancelledBasketSizeHeatmapChart />
    ) : (
      <CancelledBasketSizeLineChart />
    );
  } else {
    tabContentTwo = COMPARISON_TABS[1].tabContent;
  }
  COMPARISON_TABS[1].tabContent = tabContentTwo;
  const [selectedTab, setSelectedTab] = useState(COMPARISON_TABS[0].id);
  const handleChangeTab = id => {
    setSelectedTab(id);
  };
  const renderTabContent = () => {
    const tabContentIndex = COMPARISON_TABS.findIndex(
      ct => ct.id === selectedTab,
    );
    return COMPARISON_TABS[tabContentIndex].tabContent;
  };
  return (
    <SectionCard
      title="Avg Basket Size"
      metricKey="avgBasketSize"
      className="w-full"
    >
      <div className="mb-4">
        <ChartTabs
          tabs={COMPARISON_TABS}
          selected={selectedTab}
          onSelect={handleChangeTab}
        />
      </div>
      {renderTabContent()}
    </SectionCard>
  );
};

AvgBasketSizeChart.propTypes = {
  selectedTimePeriod: PropTypes.any,
  isTimePeriodFilterStatusChanged: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  selectedTimePeriod: makeSelectProperty('selectedTimePeriod'),
  isTimePeriodFilterStatusChanged: makeSelectProperty(
    'isTimePeriodFilterStatusChanged',
  ),
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(AvgBasketSizeChart);
